import { render, staticRenderFns } from "./OrderStatement.vue?vue&type=template&id=eba758b2&scoped=true"
import script from "./OrderStatement.vue?vue&type=script&lang=js"
export * from "./OrderStatement.vue?vue&type=script&lang=js"
import style0 from "./OrderStatement.vue?vue&type=style&index=0&id=eba758b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba758b2",
  null
  
)

export default component.exports